var baseUrl = "http://web.qx121.com:7067/api/";
var baseUrlNew = "http://192.168.2.235:8080/nbwechat/appid/dataposition";
var baseUrlAll = "http://115.238.43.212:8091/nbwechat/appid/loginService?url="
const requestData = function (url, method='get', data, callback) {
    $.ajax({
        url: url,
        method: method,
        data: data ? data : '',
        dataType: 'json',
        success: function (res) {
            callback(res);
        },
        error: function (err) {
            callback(err);
        }
    })
};
const requestPostData = function (url, method='POST', data, callback) {
    $.ajax({
        url: url,
        method: method,
        data: data ? data : '',
        dataType: 'json',
        success: function (res) {
            callback(res);
        },
        error: function (err) {
            callback(err);
        }
    })
};
//判断是否是数组类型
if (!Array.isArray) {
	Array.isArray = function(arg) {
		return Object.prototype.toString.call(arg) === '[object Array]';
	};
}
Date.prototype.Format = function (fmt) {
  var week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
    w: week[this.getDay()],
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

//数字转换成方向
function num2windD(num) {
  num = num % 360;
  let arr = [
    "北",
    "东北偏北",
    "东北",
    "东北偏东",
    "东",
    "东南偏南",
    "东南",
    "东南偏南",
    "南",
    "西南偏南",
    "西南",
    "西南偏西",
    "西",
    "西北偏西",
    "西北",
    "西北偏北",
  ];
  let v = (num / 22.5).toFixed(0);
  return arr[v];
}
function fxObj(num){
	var res = "";
	if (num == undefined) {
		res = " ";
	} else if (num == 0) {
		res = "北风";
	} else if (num == 1) {
		res = "东北偏北风";
	} else if (num == 2) {
		res = "东北风";
	} else if (num == 3) {
		res = "东北偏东风";
	} else if (num == 4) {
		res = "东风";
	} else if (num == 5) {
		res = "东南偏东风";
	} else if (num == 5) {
		res = "东南偏东风";
	} else if (num == 6) {
		res = "东南风";
	} else if (num == 7) {
		res = "东南偏南风";
	} else if (num == 8) {
		res = "南风";
	} else if (num == 9) {
		res = "东南偏南风";
	} else if (num == 10) {
		res = "西南风";
	} else if (num == 11) {
		res = "西南偏西风";
	} else if (num == 12) {
		res = "西风";
	} else if (num == 13) {
		res = "西北风";
	} else if (num == 14) {
		res = "西北偏风";
	} else if (num == 15) {
		res = "西北风";
	} else {
		res = "静风";
	}
	return res
}
function flObj (windDirection){
	var flNum="";
	if (windDirection >= 0 && windDirection <= 0.2) {
		flNum = "0级";
	} else if (windDirection >= 0.3 && windDirection <= 1.5) {
		flNum = "1级";
	} else if (windDirection >= 1.6 && windDirection <= 3.3) {
		flNum = "2级";
	} else if (windDirection >= 3.4 && windDirection <= 5.4) {
		flNum = "3级";
	} else if (windDirection >= 5.5 && windDirection <= 7.9) {
		flNum = "4级";
	} else if (windDirection >= 8.0 && windDirection <= 10.7) {
		flNum = "5级";
	} else if (windDirection >= 10.8 && windDirection <= 13.8) {
		flNum = "6级";
	} else if (windDirection >= 13.9 && windDirection <= 17.1) {
		flNum = "7级";
	} else if (windDirection >= 17.2 && windDirection <= 20.7) {
		flNum = "8级";
	} else if (windDirection >= 20.8 && windDirection <= 24.4) {
		flNum = "9级";
	} else if (windDirection >= 24.5 && windDirection <= 28.4) {
		flNum = "10级";
	} else if (windDirection >= 28.5 && windDirection <= 32.6) {
		flNum = "11级";
	} else if (windDirection >= 32.7 && windDirection <= 36.9) {
		flNum = "12级";
	} else if (windDirection >= 37.0 && windDirection <= 41.4) {
		flNum = "13级";
	} else if (windDirection >= 41.5 && windDirection <= 46.1) {
		flNum = "14级";
	} else if (windDirection >= 46.2 && windDirection <= 50.9) {
		flNum = "15级";
	} else if (windDirection >= 50.0 && windDirection <= 56.0) {
		flNum = "16级";
	} else if (windDirection >= 56.1) {
		flNum = "17级";
	}
	return flNum
}
function zwxObj (zwx){
	var zwxNum="";
	if (zwx >= 0 && zwx <= 2) {
		zwxNum = "低";
	} else if (zwx >= 3 && zwx <= 5) {
		zwxNum = "中等";
	} else if (zwx >= 6 && zwx <= 7) {
		zwxNum = "高";
	} else if (zwx >= 8 && zwx <= 10) {
		zwxNum = "甚高";
	} else if (zwx >= 11) {
		zwxNum = "极高";
	}
	return zwxNum
}
//转化xml文件  字符串转xml
function createXml(str) {
  if (document.all) {
    var xmlDom = new ActiveXObject("Microsoft.XMLDOM");
    xmlDom.loadXML(str);
    return xmlDom;
  } else return new DOMParser().parseFromString(str, "text/xml");
}

function getLegendData(data) {
  //根据xml文件获取色标
  //格式化数据
  var content = $(data).find("Rainbow Content").text();
  content = content && content.replace(/(^\s*)|(\s*$)/g, "");
  if (!content) return;
  var arr = content.split(/[\r\n]+/);
  //获取标题,第一行第一部分包含非数字
  var name = arr[0].replace(/(^\s*)|(\s*$)/g, "");
  if (isNaN(name.split(" ")[0])) {
    arr.shift();
  } else {
    name = "";
  }

  // var danwei =
  //   name != ""
  //     ? name
  //         .split(":")[1]
  //         .split("[")[1]
  //         .split("]")[0]
  //     : "";
  //获得色标数组
  var colors = [];
  for (var i = 0, l = arr.length; i < l; i++) {
    var un = arr[i].replace(/(^\s*)|(\s*$)/g, "").split(/\s+/); //根据空字符分割
    if (un.length > 1) {
      var rgb = un[1];
      var color = rgb.split(",");
      if (color.length == 4) {
        rgb = color[1] + "," + color[2] + "," + color[3];
      }
      colors.push({
        value: un[0], //值
        color: rgb, //颜色
        alias: un[2], //别名
        image: un[3], //图标
        isshowValue: false,
      });
    }
  }
  if (colors.length > 5) {
    colors[0].isshowValue = true;
    colors[colors.length - 1].isshowValue = true;
    if (colors.length % 2 == 0) {
      colors[Math.floor((colors.length - 1) / 2)].isshowValue = true;
      colors[Math.floor((colors.length - 1) / 4)].isshowValue = true;
      colors[
        Math.floor(
          (Math.floor((colors.length - 1) / 2) + colors.length - 1) / 2
        )
      ].isshowValue = true;
    } else {
      colors[Math.floor((colors.length - 1) / 2)].isshowValue = true;
      colors[Math.floor((colors.length - 1) / 4)].isshowValue = true;
      colors[
        Math.floor(
          (Math.floor((colors.length - 1) / 2) + colors.length - 1) / 2
        )
      ].isshowValue = true;
    }
  } else {
    for (var i = 0; i < colors.length; i++) {
      colors[i].isshowValue = true;
    }
  }
  return {
    colors: colors,
    title: name,
    title2: "",
  };
}

const nowtimetypes = ["DryBulTemp"]; //实时状态集合
//获取url参数
const GetRequest=function(urlStr) {//网页地址
    if (typeof urlStr == "undefined") {
        var url = decodeURIComponent(location.search); //获取url中"?"符后的字符串
    } else {
        var url = "?" + urlStr.split("?")[1];
    }
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
        }
    }
    return theRequest;//返回json对象
}



// WEBPACK FOOTER //
// ./src/assets/js/public.js